import styles from "./customer.module.css";
import { FaUserEdit, FaTelegramPlane } from "react-icons/fa";
import { BsStarHalf } from "react-icons/bs";
import { AiFillDelete } from "react-icons/ai";
import Modal from "./modal/Modal";
const BoxCustomer = ({
  item,
  deleteHandler,
  index,
  customers,
  setCustomers,
  setSelectedItem,
}) => {
  const editHandler = () => {
    setSelectedItem(index);
    console.log(index);
  };
  return (
    <div
      className={`  w-100  ${item.status ? styles.sec : styles.gry}`}
      style={{
        borderRadius: " 10px",
      }}
    >
      <div className={`d-flex flex-wrap ${styles.secondry}`}>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            نام و نام خانوادگی
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.name}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            شماره همراه{" "}
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.mobile}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            وضعیت{" "}
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.status ? "فعال" : "غیر فعال"}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            کد ملی{" "}
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.codeMeli}{" "}
          </p>
        </div>

        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            برچسب{" "}
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            <span className={styles.spn}>کاربر عادی</span>{" "}
            <span className={styles.spn}>کاربر ویژه</span>
            <span className={`text-danger ${styles.spn}`}>باشگاه مشتریان</span>
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عملیات{" "}
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModal`}
              onClick={editHandler}
            >
              <FaUserEdit />
            </p>
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModal2-${index}`}
            >
              <AiFillDelete />
            </p>
            <FaTelegramPlane className={styles.tlg} />{" "}
            <BsStarHalf className={styles.tlg} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxCustomer;
